import dayjs from 'dayjs';
import { toAmPm } from './toAmPm';

/**
 * 이벤트 날짜 범위를 포맷팅
 * @param startDate - 시작 날짜 (ISO 8601 형식)
 * @param endDate - 종료 날짜 (ISO 8601 형식)
 * @returns "Sep 9, 10:00 AM - 12:00 PM, 2024" 형식
 */
export function formatEventDateTime(startDate: string, endDate: string): string {
  if (!startDate || !endDate) return '';

  let start = dayjs(startDate);
  let end = dayjs(endDate);

  const month = start.format('MMM'); // Sep
  const day = start.format('D'); // 9
  const year = start.format('YYYY'); // 2024

  // ISO 형식 문자열을 직접 toAmPm에 전달 (시간대 변환 없음)
  const startTime = toAmPm(startDate);
  const endTime = toAmPm(endDate);

  // 당일 이벤트: 같은 날이면 시간 표시 "Sep 9, 10:00 AM - 12:00 PM, 2024"
  if (start.isSame(end, 'day')) {
    return `${month} ${day}, ${startTime} - ${endTime}, ${year}`;
  }

  // 기간 이벤트: 다른 날이면 날짜만 표시 "Sep 9 - Sep 25, 2024"
  const endMonth = end.format('MMM');
  const endDay = end.format('D');
  return `${month} ${day} - ${endMonth} ${endDay}, ${year}`;
}
